import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

// 首屏路由使用同步加载，减少首页额外一次异步请求
import Maintain from "../pages/Maintain/index.vue";

// 其他路由继续懒加载
const MyKeys = () => import("../pages/Maintain/MyKeys.vue");
const VipPage = () => import("../pages/Maintain/VipPage.vue");

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Maintain",
    component: Maintain,
    meta: {
      keepAlive: true, // 设置为 true 开启缓存
    },
  },
  {
    path: "/index",
    name: "Maintain",
    component: Maintain,
    meta: {
      keepAlive: true, // 设置为 true 开启缓存
    },
  },
  {
    path: "/maintain",
    name: "Maintain",
    component: Maintain,
    meta: {
      keepAlive: true, // 设置为 true 开启缓存
    },
  },
  { path: "/mykeys", name: "Mykeys", component: MyKeys },
  { path: "/vippage", name: "VipPage", component: VipPage },
  // Vue3 catch-all路由写法
  {
    path: "/:pathMatch(.*)*",
    name: "Maintain",
    component: Maintain,
    meta: {
      keepAlive: true, // 设置为 true 开启缓存
    },
  },
];

const router = createRouter({
  history: createWebHistory("/views/finskillshub"),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { left: 0, top: 0 };
  },
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 权限校验、登录判断等
  if (import.meta.env.DEV) {
    // 开发环境下安全地记录路由跳转，避免日志注入
    const sanitizedFrom = String(from.name || "unknown");
    const sanitizedTo = String(to.name || "unknown");
    console.log(`路由跳转: 从 ${sanitizedFrom} 到 ${sanitizedTo}`);
  }

  try {
    // 这里可以添加权限验证逻辑
    next();
  } catch (error) {
    console.error("路由守卫错误:", error);
    next(false);
  }
});

router.afterEach((to, _from) => {
  // 页面访问统计、动态标题设置等
  if (to && to["name"] == "Maintain") {
    // 站内活动主页
    let _env = navigator.userAgent.toLowerCase();
    if (_env.indexOf("eastmoney") > -1) {
      window.emtjLaunch && window.emtjLaunch("120202932362");
    } else {
      window.emtjLaunch && window.emtjLaunch("120202932370");
    }
  } else if (to && to["name"] == "Mykeys") {
    window.emtjLaunch && window.emtjLaunch("120202932444");
  } else if (to && to["name"] == "VipPage") {
    window.emtjLaunch && window.emtjLaunch("120200933320");
  } else {
    window.emtjLaunch && window.emtjLaunch("0");
  }
});

export default router;
